export default function () {
    return {
        receiptLogs: [],
        total: 0,
        receiptLogsPerPage: 50,
    };
}
